import { DCProgressObj, ModuleProgress } from 'types/dc'

// Check if dcVersion is v2.0.0 or higher
export const isV2OrHigher = (dcVersion?: string): boolean => {
  if (!dcVersion) return false
  const versionMatch = dcVersion.match(/v?(\d+)\.(\d+)\.(\d+)/)
  if (!versionMatch) return false
  const major = parseInt(versionMatch[1], 10)
  return major >= 2
}

export const mapProgressFromObj = (
  progress: DCProgressObj,
  format: 'short' | 'long' = 'short'
): string | undefined => {
  const { day, session, lesson, part, totalParts } = progress ?? {}
  if (!day || !session || !lesson || !part || !totalParts) return undefined
  switch (format) {
    case 'short':
      return `Day ${day} (S${session} L${lesson} P${part}/${totalParts})`
    case 'long':
      return `Day ${day} (Session ${session}, Lesson ${lesson}, Part ${part}/${totalParts})`
  }
}

export const calculateV2Progress = (
  moduleProgress?: ModuleProgress[]
): number | null => {
  if (!moduleProgress || moduleProgress.length === 0) return null
  const total = moduleProgress.reduce(
    (sum, { percentage }) => sum + percentage,
    0
  )

  return Math.round(total / moduleProgress.length)
}
